// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XrVY","option":"styles_option__Xxf3e","selected":"styles_selected__3gVfz"};